//@ts-nocheck
import React, { forwardRef } from 'react';
import SimpleDayPicker from '../dayDatePickerWrapper/DayDatePickerWrapper';
import DatePickerWrapper from '../DatePickerWrapper';
import DatePickerManager from '../utils/DatePickerManager';
import styles from './DatePickerSingle.module.scss';
import Arrows from './arrows/Arrows';
import WeekDays from '../weekDays/WeekDays';
import Box from '@/components/UI/box/Box';
const DatePicker = forwardRef(({
  checkInDate,
  checkOutDate,
  months,
  hoveredDate,
  onDayClick,
  onDayHover,
  todayDate,
  onNextPrevMonthClick,
  dateType = 'JALALI',
  nextRangeDays,
  isFull,
  footerChildren,
  headerChildren,
  withTooltip
}, ref) => {
  const datePickerIsInCurrentMonth = months.length > 0 && todayDate && todayDate.month == months[0]?.month && todayDate.year == months[0]?.year;
  const isLastMonth = () => {
    let lastDay = null;
    if (months?.length > 0) {
      lastDay = months[0].days[months[0].days.length - 1];
    }
    return lastDay?.ts >= nextRangeDays?.ts;
  };
  return <Box className={`${styles['calendar-wrapper']} ${styles['date-picker']}`}>
        {headerChildren && <>{headerChildren}</>}

        {months.length > 0 && <>
            <Arrows datePickerIsInCurrentMonth={datePickerIsInCurrentMonth} isLastMonth={isLastMonth} onNextPrevMonthClick={onNextPrevMonthClick} months={months} dateType={dateType} monthNameConvertor={DatePickerManager.monthNameConvertor}></Arrows>
          </>}
        <WeekDays fullWidth />

        <Box>
          {months.map((item, i) => <Box key={i} className={styles['single-day-container']}>
              <SimpleDayPicker pickerDate={item} hoveredDate={hoveredDate} checkInDate={checkInDate} checkOutDate={checkOutDate} onDayClick={onDayClick} onDayHover={onDayHover} todayDate={todayDate} nextRangeDays={nextRangeDays} isFull={isFull} withTooltip={withTooltip} />
            </Box>)}
          {footerChildren && <>{footerChildren}</>}
        </Box>
      </Box>;
});
DatePicker.displayName = 'DatePicker';
const DatePickerSingle = props => {
  return <>
      <DatePickerWrapper WrappedDatePicker={DatePicker} datePickerType="SINGLE_RANGE" ref={props.dateRef} {...props} data-sentry-element="DatePickerWrapper" data-sentry-source-file="DatePickerSingle.tsx" />
    </>;
};
export default DatePickerSingle;